module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t(_vm.$route.name)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [(_vm.dataReady) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('ul', {
    staticClass: "timeline"
  }, _vm._l((_vm.records.items), function(item, index) {
    return (_vm.$config.basicLists.eventTypes[item.event_type]) ? _c('li', {
      class: {
        'timeline-inverted': index % 2 === 0
      }
    }, [_c('div', {
      staticClass: "timeline-badge",
      class: _vm.$config.basicLists.eventTypes[item.event_type].color
    }, [_c('i', {
      staticClass: "fa",
      class: _vm.$config.basicLists.eventTypes[item.event_type].icon
    })]), _vm._v(" "), _c('div', {
      staticClass: "timeline-panel"
    }, [_c('div', {
      staticClass: "timeline-body"
    }, [_c('p', [_c('c-avatar', {
      staticClass: "float-left",
      attrs: {
        "family": item.family
      }
    }), _vm._v(" "), _c('span', [_vm._v("Семейство " + _vm._s(item.family.name) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$config.basicLists.eventTypes[item.event_type].text) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"), (item.event_type !== 'new-family') ? _c('router-link', {
      attrs: {
        "to": _vm.$config.basicLists.eventTypes[item.event_type].link + item.target_id
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.info.title) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "text-muted"
    }, [_c('i', {
      staticClass: "fa fa-clock-o",
      attrs: {
        "title": _vm._f("prettyDateTime")(item.createdAt)
      }
    }), _vm._v(" " + _vm._s(_vm._f("fromNowDateTime")(item.createdAt)))])], 1)])])]) : _vm._e()
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('f-pager', {
    attrs: {
      "total": _vm.records.total,
      "clickhandler": _vm.pageClick
    }
  })], 1)])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d9df2c7a!./~/vue-loader/lib/selector.js?type=template&index=0!./~/htmlhint-loader?{"configFile":".htmlhintrc.json","failOnError":true}!./src/components/dashboard/Events.vue
// module id = 671
// module chunks = 1